import React from "react";

export const defaultInfoBarContext = {
  isOpen: false,
  contentComponent: null,
  title: null,
  toggle(title, componentCallback) {},
};

export const InfoBarContext = React.createContext(defaultInfoBarContext);
